import { registerMultipleResources } from '../storage'
import useSuspense from './useSuspense'
import { makeOnce } from '../../utils/makeOnce'
import { ResourceMap } from '../manifest'
import { ListParams, ResourceType } from '../types'

/**
 * Use a list of resources based on the parameters provided. Suspend until the API replies.
 *
 * @param type
 * @param params
 */
export default function useResourceList<K extends ResourceType>(type: K, ...params: ListParams<K>) {
  const fetcher = getResourceListFetcher(type)
  return useSuspense(fetcher, params[0], type)
}

/**
 * This returns a wrapper around the list API call that converts the call
 *
 * @param resourceType
 */
export function getResourceListFetcher<K extends ResourceType, T extends ResourceMap[K]['list']>(resourceType: K) {
  const asyncFetch = ResourceMap[resourceType].list

  return makeOnce(asyncFetch, async (args: any): Promise<ResourceResponseBase<Awaited<ReturnType<T>>>> => {
    const response = await asyncFetch(args!)
    const resourceIds: string[] = registerMultipleResources(response.data)
    return { ids: resourceIds, response }
  })
}

type ResourceResponseBase<T> = {
  ids: string[]
  response: T
}
